import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import { TariffName } from '../../../channel-details/optimizer/configuration/types/tariff-kind';
import { EcoBoxIcon } from '../../types/types';
import { ecoParamsByHeatmapColor, getEcoBoxBackgroundColor } from '../../utils/eco-box';
import { LeafLeft, LeafRight, FaceLeft, FaceRight } from './eco-icons';

type EcoBoxProps = {
  color?: string | null;
  subTitle?: string;
  tariff: TariffName | null;
};

export const EcoBox: React.FC<EcoBoxProps> = ({ color, subTitle, tariff }) => {
  const { t } = useTranslation('dashboard');
  const backgroundColor = color ? getEcoBoxBackgroundColor(color) : null;
  const ecoParams = color ? ecoParamsByHeatmapColor[color] : null;
  const isG11 = tariff === TariffName.G11;

  const renderIcons = () => {
    if (!ecoParams || isG11) return null;

    return ecoParams.icon === EcoBoxIcon.Leaf ? (
      <>
        <LeafLeft iconColor={ecoParams.iconColor} />
        <LeafRight iconColor={ecoParams.iconColor} />
      </>
    ) : (
      <>
        <FaceLeft iconColor={ecoParams.iconColor} />
        <FaceRight iconColor={ecoParams.iconColor} />
      </>
    );
  };

  if (!backgroundColor) return null;

  return (
    <Stack sx={{ backgroundColor }} alignItems="center">
      <Stack position="relative" alignItems="center" paddingTop={5} paddingBottom={5} width="100%">
        <Typography sx={{ fontWeight: 700, fontSize: 18 }}>
          {t(`tariff.levels.${!isG11 ? ecoParams?.text : 'same'}`)}
        </Typography>
        {subTitle && <Typography>{subTitle}</Typography>}
        {renderIcons()}
      </Stack>
    </Stack>
  );
};
